import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import * as DF from 'fixedassets/components/detail/field';

class AssetDetailGeneral extends Component {
  render = () => {
    const [_location, ..._sublocations] =
      (this.props.asset.location && this.props.asset.location.split('.')) || [];

    let location,
      sublocations = [];
    if (this.props.locations && this.props.sublocations) {
      const sublocationsElements = this.props.sublocations.reduce((re, s) => [...re, ...s], []);
      location = this.props.locations.find((l) => l.id === _location);
      sublocations = _sublocations
        .map((id) => sublocationsElements.find((s) => s.id === id))
        .filter((s) => s);
    }

    const employee = this.props.asset._employee;

    return (
      <Form.Section title={this.props.t('assets.section.location')}>
        <div className="row">
          {employee && (
            <div className="col-md-12 mb-4">
              <div>
                {this.props.t('assets.fields.employee')}:
              </div>
              <div className="d-flex align-items-center">
                {employee.imgUrl && (
                  <img
                    src={employee.imgUrl}
                    alt={`${employee.name} ${employee.lastname}`}
                    style={{
                      width: 70,
                      height: 70,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      marginRight: 20,
                      border: '1px solid #ccc',
                    }}
                  />
                )}
                <div>
                  <div>
                    {employee.name + ' ' + employee.lastname}
                  </div>
                  <div style={{ fontSize: 14, color: '#555' }}>{employee.position}</div>
                  <div style={{ fontSize: 13, color: '#888' }}>{employee.email}</div>
                </div>
              </div>
            </div>
          )}

          {location && <DF.Text label={'assets.fields.location'} value={location.name} />}

          {sublocations &&
            sublocations.map((sublocation, index) => (
              <DF.Text
                key={sublocation.id}
                label={`${this.props.t('assets.fields.sublocation')} ${index + 1}`}
                value={sublocation.name}
              />
            ))}
        </div>
      </Form.Section>
    );
  };
}

export default translate()(AssetDetailGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailLocation.js